<template>
  <div class="Returning_Area">
    <div class="container">
      <div class="sharing_title">
        <img src="../../img/return.svg" alt="海外返國專區" />
        <h3 :style="{ fontSize: fontSize.h3 + 'em' }">海外返國專區</h3>
      </div>
      <div class="uk-child-width-1-3@m" uk-grid>
        <Carousel
          :data="data.returnEmploymnet"
          justify="Employment"
          bgc="#003e61"
        />
        <Carousel
          :data="data.returnBusiness"
          justify="Employment"
          bgc="#003e61"
        />
        <div class="web_pic_item" alt="海外返國專區">
          <router-link
            :to="`/return_employment/employment/${data.employmnetInfo.pageId}`"
            style="display: block"
            title="海外返國專區文章"
          >
            <p
              :style="{ fontSize: fontSize.p + 'em' }"
              class="sec_title return_sec_title"
            >
              {{ data.employmnetInfo.type }}
            </p>
            <div v-if="data.employmnetInfo.video" class="video">
              <div class="iframe">
                <div v-html="data.employmnetInfo.video" />
              </div>
            </div>
            <div v-else class="pic">
              <img :src="data.employmnetInfo.image" alt="海外返國專區圖片" />
            </div>
            <p class="text_content" :style="{ fontSize: fontSize.p + 'em' }">
              {{ data.employmnetInfo.title }}
            </p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Carousel from "../CarouselFullScreen.vue";
import { inject, reactive } from "vue";
import { apiReturnWorkEachType } from "@/api/api.js";
import { toArticleFormat } from "@/util/article";

let fontSize = inject("fontSize");

const data = reactive({
  employmnetInfo: {},
  returnEmploymnet: [],
  returnBusiness: [],
});
const fetchReturnData = async () => {
  const {
    data: { returnNew, returnEmployment, returnBusiness },
  } = await await apiReturnWorkEachType();
  console.log(returnBusiness);
  data.employmnetInfo = toArticleFormat(returnNew);
  data.returnEmploymnet = returnEmployment.map((d) => toArticleFormat(d));
  data.returnBusiness = returnBusiness.map((d) => toArticleFormat(d));
};
fetchReturnData();
</script>

<style scoped lang="scss">
.uk-grid {
  flex-wrap: nowrap;
  @media screen and (max-width: 960px) {
    flex-wrap: wrap;
  }
}
.container {
  .sharing_title {
    @include flex_center();
    img {
      width: 7%;
    }
  }

  .web_pic_item {
    position: relative;
    margin-bottom: 45px;
    .pic {
      width: 100%;
      aspect-ratio: 16 / 9;
      overflow: hidden;
      img {
        border-radius: 10px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    p {
      margin-top: 5px;
      color: $black_color;
      text-align: left;
      &.sec_title {
        position: absolute;
        top: 6%;
        right: 4%;
        color: #fff;
        padding: 5px 10px;
        background-color: #003e61;
      }
    }
  }
}

.video {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .iframe {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    :deep iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
